import { FC } from 'react';
import { logosData }  from '../configs';
import { Logo } from './Logo';

export const MainPartnerLogo: FC = () => {

  return (
    <div className="m-3 w-auto max-w-28 h-20 md:h-24 lg:h-28">
      <Logo 
        path={logosData.mainPartnerLogo.path} 
        target="_blank" 
        rel="noreferrer" 
        src={logosData.mainPartnerLogo.src} 
        name={logosData.mainPartnerLogo.name} 
        className="h-full max-w-full object-contain" 
      />
    </div>
  );
};